import { useQuery } from '@tanstack/react-query'
import { webApi } from '@/services/webApi'
import { mapApiMagazine } from '@/lib/apiNormalize'
import type { MagazineIssue } from '@/data/mock/magazine'

/**
 * Live QBC E-Books / magazines (admin-uploaded). Returns reader-ready
 * MagazineIssue objects backed by the uploaded PDF.
 */
export function useMagazines() {
  const query = useQuery({
    queryKey: ['web', 'magazines'],
    queryFn: () => webApi.magazines(),
    staleTime: 5 * 60_000,
  })

  const issues: MagazineIssue[] = (query.data ?? []).map(mapApiMagazine)

  return { issues, isLoading: query.isLoading, isError: query.isError }
}
